import React from "react";
import { graphql } from "gatsby";

import SEO from '../components/seo/head';
import PageContentContainerWide from '../components/page-content-container-wide';
import Pagination from './../components/pagination/index';

import CaseStudyCardContainer from '../components/case-studies/card-container';
import CaseStudyCard from '../components/case-studies/card';

import BlogCategoryList from '../components/blogs/blog-category-list';
import BlogCategoryItem from '../components/blogs/blog-category';

const CaseStudies = ({
    data,
    pageContext
}) => {
    let caseStudies = data.contentfulCaseStudiesCategories.case_studies;
    const { limit, skip, pageCount, currentPage } = pageContext;

    let caseStudiesToShow = caseStudies.slice(skip, skip + limit);

    return (
        <PageContentContainerWide hasMargin>
            <h1 style={{
                marginBottom: '1em',
                marginTop: '.5em'
            }}>{data.contentfulCaseStudiesCategories.title}</h1>

            <BlogCategoryList>
                <BlogCategoryItem baseUrlOverwrite={'/case-studies'} title={'All'} link={''} active={false} />
                {data.allContentfulCaseStudiesCategories.edges.map(blogCategory => blogCategory.node.title?.length > 0 && blogCategory.node.slug?.length > 0 && (
                    <BlogCategoryItem baseUrlOverwrite={'/case-studies'} key={`blog-category-` + blogCategory.node.id} active={blogCategory.node.slug === pageContext.slug} {...blogCategory.node} />
                ))}
            </BlogCategoryList>
            <CaseStudyCardContainer>
                {caseStudiesToShow.map((node) => (
                    <CaseStudyCard key={node.id} {...node} />
                ))}
            </CaseStudyCardContainer>
            <Pagination 
                currentPage={currentPage}
                pageCount={pageCount}
                path={`/case-studies/${pageContext.slug}`}
                pageNumberPrefix={`p`}
            />
        </PageContentContainerWide>
    );
}

export default CaseStudies;

//SEO bits
export const Head = ({ data, location }) => (
    <SEO
      location={location}
      metaTitle="Case Studies | Ideal Heating"
      metaDescription="Read our case studies to see how we have helped our customers with their heating needs."
      robotsMetaTag="index, follow"
    />
  )

export const query = graphql`
  query (
      $id: String!
  ) {
    allContentfulCaseStudiesCategories (filter: {node_locale: {eq: "en-US"}}) {
        edges {
            node {
                id
                title
                slug
            }
        }
    }
    contentfulCaseStudiesCategories (id: {eq: $id}) {
        title
        case_studies {
            ...caseStudyCardFields
        }
    }
}
`;